window.initMap = () => {
  const event = new CustomEvent('google-maps-callback')
  window.dispatchEvent(event)
}
